import { render, staticRenderFns } from "./congeners.vue?vue&type=template&id=23e39466"
import script from "./congeners.vue?vue&type=script&lang=js"
export * from "./congeners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports